import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Student_Point } from "../../shared/data.service";
import { GroupPointsInsertRequest } from "../../shared/GroupPointsInsertRequest";
import { PointTransactionInfo, PointTransactionRequest } from "../../shared/PointTransactionRequest";

@Component({
	selector: "app-group-add-point",
	templateUrl: "./group-add-point.component.html",
	styleUrls: ["./group-add-point.component.css"],
})
export class GroupAddPointComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private PBISService: DataService_Student_Point,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SchoolName = this.dialogConfig.data.SchoolName;
		this.GroupID = this.dialogConfig.data.GroupID;
		this.GroupName = this.dialogConfig.data.GroupName;

		this.loadPointItem();
	}

	//////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////

	user: any;
	GroupID: any;
	GroupName: any;

	SchoolID: any;
	SchoolName: any;

	SelectedPoint: any;
	lstPoints: any = [];

	ItemLoading: any = true;
	Processing: any = false;

	AddStudentPrompt: boolean = false;

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////
	loadPointItem() {
		this.ItemLoading = true;

		var result = this.PBISService.PBISPointItemSelectList(1, this.SchoolID); //1 for Behavior?
		result.subscribe(
			(response) => {
				this.lstPoints = response;

				this.SelectedPoint = this.lstPoints[0];

				this.ItemLoading = false;
			},
			(error) => {
				this.ItemLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////
	onAdd() {
		if (this.lstPoints.length == 0) {
			return;
		}

		this.confirmationService.confirm({
			key: "addgroupwarning",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: 'NOTE: this will add a point to all of the students assigned to "' + this.GroupName + '". Do you want to continue?',
			header: "Confirm Add Points",
			icon: "fa",
			accept: () => {
				this.FinishAdd();
			},
		});
	}

	FinishAdd() {
		this.Processing = true;

		//
		// Create Request
		//

		let parms: GroupPointsInsertRequest = {
			GroupID: this.GroupID,
			PointsTransactionTypeID: 1, // 1 = Earned Point
			PointsItemID: this.SelectedPoint.PointsItemID,
			PointsItemValue: this.SelectedPoint.PointsItemValue,
			IsVoid: 0,
			c_PersonID: this.user.personID,
			AddStudentPrompt: this.AddStudentPrompt == true ? 0 : 1,
		};

		//
		// Call SP
		//

		var result = this.PBISService.GroupPointsInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Point was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the point: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.ItemLoading || this.Processing;
	}

	//////////////////////////////////////////////////////////////////
}
